<template>
	<div class="hybridlist" ref="hybridListRef">
		<div class="grid">
			<Spinner v-show="loading" />
			<aside class="col-12_sm-12_md-3 hybridlist__filters">
				<HybridlistFilters
					:value="filters"
					@update="updateFilters"
				></HybridlistFilters>
			</aside>
			<div class="col-12_sm-12_md-9">
				<HybridlistItem
					v-for="(listitem, index) in listItems"
					:key="index + listitem.collapsedProperties[0].value"
					:data="listitem"
					:simplelist="dataProps.simplelist"
					:translations="translations"
					:arialabelhidecontent="dataProps.arialabelhidecontent"
					:arialabelshowcontent="dataProps.arialabelshowcontent"
					:arialabelshowmore="dataProps.arialabelshowmore"
					:arialabelshowless="dataProps.arialabelshowless"
					:arialabelcarouselshowlargeimages="
						dataProps.arialabelcarouselshowlargeimages
					"
					:arialabelcarouselclosebutton="
						dataProps.arialabelcarouselclosebutton
					"
					:arialabelcarouseldotbutton="
						dataProps.arialabelcarouseldotbutton
					"
					:arialabelnext="dataProps.arialabelnext"
					:arialabelprevious="dataProps.arialabelprevious"
				></HybridlistItem>
			</div>
			<footer class="col-12 text--center">
				<pagination
					:totalItems="totalItems"
					:pageSize="parseInt(dataProps.pagesize)"
					:currentPage="parseInt(pageIndex)"
					@changePageIndex="changePageIndex"
					:ariaLabelPaginationGotoPage="
						dataProps.arialabelpaginationgotopage
					"
					:ariaLabelPaginationNav="dataProps.arialabelpaginationnav"
					:ariaLabelPaginationNext="dataProps.arialabelpaginationnext"
					:ariaLabelPaginationPrev="dataProps.arialabelpaginationprev"
					:ariaLabelPaginationActivePage="
						dataProps.arialabelpaginationactivepage
					"
				></pagination>
			</footer>
		</div>
	</div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import HybridlistItem from "./hybridlistItem.vue";
import HybridlistFilters from "./hybridlistFilters.vue";
import Spinner from "../../../shared/script/vue/Spinner.vue";
import Pagination from "../pagination/pagination.vue";
import axios from "axios";

const apiurl = ref("/api/hybridList/list");
const listItems = ref([]);
const filters = ref([]);
const pageIndex = ref(0);
const loading = ref(false);
const totalItems = ref(0);
const dataProps = ref({});

const hybridListRef = ref("hybridListRef");

onMounted(() => {
	dataProps.value = hybridListRef.value?.parentElement?.dataset;
	checkPageIndex();
	fetchData().then(() => {
		checkFilterParameters(true);
	});
});

const fetchData = async (setQueryParameter = false) => {
	loading.value = true;
	try {
		let response = await axios.post(apiurl.value, {
			ListId: parseInt(dataProps.value.listid),
			IncludeFilters: true,
			PageIndex: pageIndex.value,
			Filters: activeFilters.value,
			Culture: dataProps.value.culture,
		});

		if (response.status == 200) {
			listItems.value = response.data.items;
			totalItems.value = response.data.totalPages;
			if (response.data.filters && response.data.filters.length) {
				filters.value = response.data.filters;
				checkFilterParameters(false);
			}
		} else {
			listItems.value = [];
		}
		loading.value = false;
		if (setQueryParameter) {
			utilities.setQueryStringParameter("pageIndex", pageIndex.value);
		}
		return response;
	} catch (err) {
		alert(err);
		return false;
	}
};

const changePageIndex = (index) => {
	let indexPlusOne = index + 1;
	if (
		indexPlusOne >= 1 &&
		indexPlusOne <= Math.ceil(totalItems.value / dataProps.value.pagesize)
	) {
		pageIndex.value = index;
		fetchData(true);
	}
};

const updateFilters = (updatedFilters) => {
  filters.value = JSON.parse(JSON.stringify(updatedFilters));
  pageIndex.value = 0;
  utilities.setQueryStringParameter('filters', JSON.stringify(activeFilters.value));
  fetchData();
};

const checkPageIndex = () => {
	const urlParams = new URLSearchParams(window.location.search);
	const pageIndexParam = urlParams.get("pageIndex");
	if (pageIndexParam) {
		pageIndex.value = parseInt(pageIndexParam, 10);
	}
};

const checkFilterParameters = (reload = false) => {
	const urlParams = new URLSearchParams(window.location.search);
	const filtersParam = urlParams.get("filters");
	if (filtersParam) {
		let filterArr = JSON.parse(filtersParam);
		filterArr.forEach((element) => {
			let searchedFilter = filters.value.find(
				(filter) => filter.name == element.name
			);
			element.values.forEach((value) => {
				let searchedFilterNested = searchedFilter.values.find(
					(filter) => filter.name == value
				);
				searchedFilterNested.value = true;
			});
		});
		filters.value = JSON.parse(JSON.stringify(filters.value));
	}
	if (reload) {
		fetchData(false);
	}
};

const translations = computed(() => {
	return dataProps.value.translations
		? JSON.parse(dataProps.value.translations)
		: {};
});

const activeFilters = computed(() => {
	let activeFilters = [];
	filters.value?.forEach((element) => {
		let pushElement = {
			name: element.name,
			values: [],
		};
		element.values.forEach((filterValue) => {
			if (filterValue.value == true) {
				pushElement.values.push(filterValue.name);
			}
		});
		if (pushElement.values.length > 0) {
			activeFilters.push(pushElement);
		}
	});
	return activeFilters;
});
</script>
